import React, { Component } from "react";
import SearchWrapper from "./layouts/SearchWrapper";
import HeaderTwo from "./layouts/HeaderTwo";
import BannerTwo from "./layouts/BannerTwo";
import HowCanHelp from "./layouts/HowCanHelp";
import AboutArea from "./layouts/AboutArea";
import WorkGallery from "./layouts/WorkGallery";
import WhyChooseUs from "./layouts/WhyChooseUs";
//import RecentProductsTwo from "./layouts/RecentProductsTwo";
import Cta from "./layouts/Cta";
//import Testimonials from "./layouts/Testimonials";
//import BlogArea from "./layouts/BlogArea";
import Footer from "./layouts/Footer";
import SEO from "./SEO";

class HomeTwo extends Component {
    render() {
        return (
            <>
                <SEO 
                    title="Home | iScreenFix | iPhone repair & Computer repair | Data Backup | Website Developer | 981 Hackler Street Unit E, Myrtle Beach, SC, USA"
                    description="iScreenFix Business specializes in mobile phone and iPhone repair, data recovery, and computer repair services of all makes. They also provide cloud data backup, RMM, website development, and SEO and social media posting services to their clients."
                    keywords="iPhone repair, computer repair, data recovery, iPhone screen replacement, laptop repair, mobile repair, PC repair, Myrtle Beach"
                    canonical="https://www.iscreenfix.com"
                />
                <SearchWrapper />
                <HeaderTwo />
                <BannerTwo />
                <HowCanHelp />
                <AboutArea design={'home_2'} />
                <WorkGallery />
                <WhyChooseUs />
                {/* <RecentProductsTwo /> */}
                <Cta />
                {/* <Testimonials design={'home_1'} /> */}
                {/* <BlogArea /> */}
                {/*    <Brands /> */}
                <Footer />
            </>
        );
    }
}

export default HomeTwo;